import request from '../http/index.js'

export function login (data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function getInfo () {
  return request({
    url: '/getSysUserInfo',
    method: 'get'
  })
}
export function reopenInvoice (data) {
  return request({
    url: `/invoice/replaceInvoice`,
    method: 'post',
    data
  })
}
export function checkIcbcPayState (id) {
  return request({
    url: `/icbcPay/aggreGatePay/${id}`,
    method: 'get'
  })
}
export function newCheckIcbcPayState (moIds) {
  return request({
    url: `/icbcPay/b2COnlineConsumptionInquiry`,
    method: 'post',
    data: { moIds }
  })
}
export function update4UserInvoice (data) {
  return request({
    url: `/invoice/update4User`,
    method: 'post',
    data
  })
}
export function getOrderDetailById (data) {
  return request({
    url: `/magorder/getOrderDetailById`,
    method: 'get',
    params: data
  })
}
export function getInvoicePdf (data) {
  return request({
    url: `/invoice/getInvoicePdfurl/${data.id}`,
    method: 'get'
  })
}

export function logout () {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function getOrderDateLists (data) {
  return request({
    url: `/productitem/getPageList`,
    method: 'post',
    data
  })
}

export function getProductuniYearList() {
  return request({
    url: `/productunit/listYear`,
    method: 'get'
  })
}

export function getArea (data) {
  return request({
    url: `/area/tree`,
    method: 'post',
    data
  })
}

export function getCommUnitLists (data) {
  return request({
    url: `/commonsub/getPageList`,
    method: 'post',
    data
  })
}
export function updateBatchCommonsub (data) {
  return request({
    url: `/commonsub/batchImportCommonsubByExcel`,
    method: 'post',
    data
  })
}
export function addCommUnit (data) {
  return request({
    url: `/commonsub/add`,
    method: 'post',
    data
  })
}

export function deleteCommUnit (id) {
  return request({
    url: `/commonsub/delete/${id}`,
    method: 'post'
  })
}

export function getCommUnitDetail (data) {
  return request({
    url: `/commonsub/info/${id}`,
    method: 'get'
  })
}

export function updateCommUnit (data) {
  return request({
    url: `/commonsub/update`,
    method: 'post',
    data
  })
}

export function getCommVoiceLists (data) {
  return request({
    url: `/commoninvoice/getPageList`,
    method: 'post',
    data
  })
}
export function addCommVoice (data) {
  return request({
    url: `/commoninvoice/add`,
    method: 'post',
    data
  })
}

export function deleteCommVoice (id) {
  return request({
    url: `/commoninvoice/delete/${id}`,
    method: 'post'
  })
}

export function getCommVoiceDetail (data) {
  return request({
    url: `/commoninvoice/info/${id}`,
    method: 'get'
  })
}

export function updateCommVoice (data) {
  return request({
    url: `/commoninvoice/update`,
    method: 'post',
    data
  })
}

export function getOrderLists (data) {
  return request({
    url: `/magorder/getPageList`,
    method: 'post',
    data
  })
}
export function addOrder (data) {
  return request({
    url: `/magorder/add`,
    method: 'post',
    data
  })
}
export function addMoreOrder (data) {
  return request({
    url: `/magorder/multipleAdd`,
    method: 'post',
    data
  })
}
export function addMoreBreakOrder (data) {
  return request({
    url: `/magorder/multipleAddWitBrokenOrder`,
    method: 'post',
    data
  })
}
export function newAddMoreBreakOrder (data) {
  return request({
    url: `/magorder/multiplePlaceWitBrokenSubscribe4Pc`,
    method: 'post',
    data
  })
}
export function confirmRepeatOrder (id) {
  return request({
    url: `/magorder/confirmRepeatOrder4Pc?uuid=${id}`,
    method: 'get'
  })
}
export function getOrderDetailsList (data) {
  return request({
    url: `/magorder/listOrderDetails`,
    method: 'get',
    params: data
  })
}

export function deleteOrder (id) {
  return request({
    url: `/magorder/delete/${id}`,
    method: 'post'
  })
}

export function getOrderDetail (data) {
  return request({
    url: `/magorder/info/${id}`,
    method: 'get'
  })
}

export function updateOrder (data) {
  return request({
    url: `/magorder/update`,
    method: 'post',
    data
  })
}

export function updateByOrder (data) {
  return request({
    url: `/magorder/updateByOperator`,
    method: 'post',
    data
  })
}
export function multipleSubscribeOrder (data) {
  return request({
    url: `/magorder/multipleSubscribeOrder`,
    method: 'post',
    data
  })
}
export function dispatchSubscribe (data) {
  return request({
    url: `/magorder/dispatchSubscribe`,
    method: 'post',
    data
  })
}
export function dispatchSubscribeOrder (data) {
  return request({
    url: `/magorder/dispatchSubscribeOrder`,
    method: 'post',
    data
  })
}

export function getMyOrders (data) {
  return request({
    url: `/magorder/getMyOrderPageList`,
    method: 'post',
    data
  })
}

export function consolidatedInvoice (data) {
  return request({
    url: `/invoice/consolidatedInvoice`,
    method: 'post',
    data
  })
}

export function getAppid (type) {
  return request({
    url: `/wxpay/wxCfgAppId/${type == 0 || type == 1 ? '?type=' + type : ''}`,
    method: 'get'
  })
}
export function downloadTemplate () {
  return request({
    url: `/commonsub/downloadTemplate`,
    method: 'get',
    responseType: 'blob'
  })
}
export function downloadTemplateOrder () {
  return request({
    url: `/magorder/downloadTemplate4MultipleSubscribe`,
    method: 'get',
    responseType: 'blob'
  })
}
export function downloadTemplateOrderOne () {
  return request({
    url: `/magorder/downloadTemplate4DispatchSubscribe`,
    method: 'get',
    responseType: 'blob'
  })
}
export function getQrcodeUrl ({id}) {
  return request({
    url: `/icbcPay/qrcode/${id}`,
    method: 'get'
  })
}
export function newGetQrcodeUrl (data) {
  return request({
    url: `/icbcPay/ConsolidatedPayment4Pc`,
    method: 'post',
    data
  })
}
export function getQrcodeUrl2 (data) {
  return request({
    url: `/icbcPay/qrcode`,
    method: 'post',
    data
  })
}
export function newGetQrcodeUrl2 (data) {
  return request({
    url: `/icbcPay/ConsolidatedPayment4Pc`,
    method: 'post',
    data
  })
}

export function getMyOrderDetail (id) {
  return request({
    url: `/magorder/info/${id}`,
    method: 'get'
  })
}

export function newGetMyOrderDetail (data) {
  return request({
    url: `/magorder/queryOrderCreateSuccessView`,
    method: 'post',
    data
  })
}

export function getChildOrder (orderId, data) {
  return request({
    url: `/magorder/getSubOrderList/${orderId}`,
    method: 'post',
    data
  })
}

export function addPayInfo (data) {
  return request({
    url: `/magorder/pay`,
    method: 'post',
    data
  })
}
export function newAddPayInfo (data) {
  return request({
    url: `/magorder/batchPay`,
    method: 'post',
    data
  })
}

export function newSaveVoucher (data) {
  return request({
    url: `/magorder/batchUploadVoucherImg`,
    method: 'post',
    data
  })
}

export function saveVoucher (data) {
  return request({
    url: `/magorder/uploadVoucherImg`,
    method: 'post',
    data
  })
}

export function uploadFile (data) {
  return request({
    url: `/upload`,
    method: 'post',
    data
  })
}

export function getKaiPiaoLists (data) {
  return request({
    url: `/invoice/getInvoiceByOrderId`,
    method: 'post',
    data
  })
}

export function getFukuanLists (data) {
  return request({
    url: `/payment/getPageList`,
    method: 'post',
    data
  })
}

export function getDefaultUnit () {
  return request({
    url: `/commonsub/getDefault`,
    method: 'post'
  })
}
export function setDispatchOrders (data) {
  return request({
    url: `/magorder/dispatchOrders`,
    method: 'post',
    data
  })
}
export function updateDispatchOrders (data) {
  return request({
    url: `/magorder/dispatchOrderUpdate`,
    method: 'post',
    data
  })
}
export function getDispatchOrder (id) {
  return request({
    url: `/magorder/dispatchOrderDetail/${id}`,
    method: 'post'
  })
}

export function setDefaultUnit (id, isdefault) {
  return request({
    url: `/commonsub/modifyDefault/${id}/${isdefault}`,
    method: 'post'
  })
}

export function getUserInfoDetail (id) {
  return request({
    url: `/sysUser/info/${id}`,
    method: 'get'
  })
}

export function updateUserInfo (data) {
  return request({
    url: `/sysUser/update`,
    method: 'post',
    data
  })
}

export function newUpdatePayType (data) {
  return request({
    url: `/magorder/batchUpdatePayType`,
    method: 'post',
    data
  })
}
export function updatePayType (data) {
  return request({
    url: `/magorder/update/payType/${data.moId}/${data.payType}`,
    method: 'post'
  })
}

export function updateUserInfoPass (data) {
  return request({
    url: `/sysUser/updatePassword`,
    method: 'post',
    data
  })
}

export function getGeoDivisionTree (data) {
  return request({
    url: `/area/tree`,
    method: 'post',
    data
  })
}
export function getStatCatalogTree (data) {
  return request({
    url: `/statCatalog/tree`,
    method: 'post',
    data
  })
}
export function uploadExcelCommon (data) {
  return request({
    url: `/commonsub/batchImportCommonsubByExcel`,
    method: 'post',
    data
  })
}
export function uploadExcelOrder (data) {
  return request({
    url: `/magorder/multipleSubscribe`,
    method: 'post',
    data
  })
}
export function importTempCommonsub (data) {
  return request({
    url: `/commonsub/importTemp2Commonsub`,
    method: 'post',
    data
  })
}
export function updateCommonsubTemp (data) {
  return request({
    url: `/commonsub/updateCommonsubTemp`,
    method: 'post',
    data
  })
}

export function createWXPay (id) {
  return request({
    url: `/wxpay/createWithQrCode/${id}`,
    method: 'get'
  })
}

export function createALIPay (id) {
  return request({
    url: `/alipay/createAlipay/${id}`,
    method: 'get'
  })
}

export function queryWXPay (id) {
  return request({
    url: `/wxpay/orderQuery/${id}`,
    method: 'get'
  })
}

export function queryALI (id) {
  return request({
    url: `/alipay/orderQuery/${id}`,
    method: 'get'
  })
}

export function queryPay (id) {
  return request({
    url: `/magorder/orderQuery/${id}`,
    method: 'get'
  })
}

export function doStatics (data) {
  return request({
    url: `/magorder/myOrderSummary`,
    method: 'post',
    data
  })
}
export function invoiceAbo (data) {
  return request({
    url: `/invoice/invoiceRepeal`,
    method: 'post',
    data
  })
}

export function applyRefund (id) {
  return request({
    url: `/magorder/applyRefund/${id}`,
    method: 'get'
  })
}

export function myInvoice (data) {
  return request({
    url: `/invoicedetail/getMyPageList`,
    method: 'post',
    data
  })
}

export function getInvoiceDetail (id) {
  return request({
    url: `/invoice/info/${id}`,
    method: 'get'
  })
}

export function addInvoice (data) {
  return request({
    url: `/invoice/add`,
    method: 'post',
    data
  })
}

export function getPayDetail (data) {
  return request({
    url: `/payment/getPageList`,
    method: 'post',
    data
  })
}
export function treeByUserRole (data) {
  return request({
    url: `/statCatalog/treeByUserRole`,
    method: 'post',
    data
  })
}
export function subscriberAdminProSubDetails (data) {
  return request({
    url: `/magorder/subscriberAdminProSubDetails`,
    method: 'post',
    data
  })
}

export function getPayPics (vid, voTypeName) {
  return request({
    url: `/voucherimg/getListByPayId/${vid}/${voTypeName}`,
    method: 'post'
  })
}

export function getKaiPiaoDetail (id) {
  return request({
    url: `/invoice/getInvoiceByOrderId/` + id,
    method: 'post'
  })
}

export function getExpressLists (data) {
  return request({
    url: `/express/getMyPageList`,
    method: 'post',
    data
  })
}
export function getProductunitLists (data) {
  return request({
    url: `/productunit/getPageList`,
    method: 'post',
    data
  })
}

export function getOpenInvoiceType (data) {
  return request({
    url: `/organize/getOpenInvoiceType`,
    method: 'get',
    data
  })
}

export function sendInvoice (data) {
  return request({
    url: `/invoice/invoiceReSend`,
    method: 'post',
    data
  })
}

export function mailingList (data) {
  return request({
    url: `/mailing/getPageList`,
    method: 'post',
    data
  })
}

export function paytypeList (data) {
  return request({
    url: `/paytype/getPageList`,
    method: 'post',
    data
  })
}

export function codeLogin (data) {
  return request({
    url: `/login/messageMatch`,
    method: 'post',
    data
  })
}

export function sendCode (data) {
  return request({
    url: `/login/messageCode/${data.phone}`,
    method: 'get'
  })
}

// 微信登陆获取token
export function getWxUserInfo (data) {
  return request({
    url: `/login/weixin/pc/userInfo?code=${data.code}&state=${data.state}`,
    method: 'get',
    data
  })
}

// 获取期刊详情
export function getPeriodicalInfo (id) {
  return request({
    url: `/productunit/info/${id}`,
    method: 'get'
  })
}

export function importOrder (data) {
  return request({
    url: `/magorder/importOrder`,
    method: 'post',
    data
  })
}

export function getStaticsDivisionTree (id) {
  return request({
    url: `/statCatalog/infoByCataId/${id}`,
    method: 'get'
  })
}
